var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selected"},[_c('div',{staticClass:"text"},[_vm._v("请选座位")]),_c('div',{ref:"scroll",staticClass:"scroll"},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"scroll-ul"},[_c('span',{staticStyle:{"margin-left":"1.2rem","color":"#666","font-size":"0.7rem"}})])
}]

export { render, staticRenderFns }